import makeStyles from "@material-ui/core/styles/makeStyles";
import bemVindo from "../assets/img/bem-vindo.webp";

const useStyles = makeStyles(theme => ({
  icone: {
    fontSize: "32px", 
    color: "#FFFFFF",
    marginRight: "24px",
  },
  subtitulo: {
    color: "#FFFFFF", 
    fontSize: "16.8px", 
    margin: "0",
    fontWeight: "600", 
  },
  titulo: {
    color: "#FFFFFF", 
    fontSize: "24.19px", 
    fontWeight: "600", 
    textTransform: "none", 
    margin: "0"
  },
  containerParagrafo: {
    width: "auto"
  },
  paragrafo: {
    color: "#FFFFFF", 
    fontSize: "16.8px", 
    margin: "0", 
    textAlign: "start",
    fontWeight: 600,
    [theme.breakpoints.down('sm')]: {
        textAlign: 'center'
    }
  },
  rootGrid: {
    display: "grid", 
    flexDirection: "column", 
    paddingTop: "10vh", 
    gap: "8px",
    "@media (min-height: 640px)": {
      gap: "24px",
    }
  },
  imgBackground: {
    position: 'fixed',
    left: 0,
    top: 0,
    backgroundSize: "cover",
    backgroundImage: `url(${bemVindo})`,
    height: "100vh",
    width: "100vw",
    textAlign: "center",
  },
  botaoAvancar: {
    display: 'flex',
    position: 'fixed',
    bottom: 0,
    left: 0,
    width: '100vw',
    padding: '16px',
    textAlign: 'right',
    [theme.breakpoints.up('sm')]: {
        display: 'block',
        position: 'relative'
    },
    '&button': {
      height: '48px',
      flex: '0',
      [theme.breakpoints.down('sm')]: {
          flex: '1'
      }
    }

  }
}));

export default function PageBemVindoMeuINSS(props) {
  const classes = useStyles();

  return (
    <div className={classes.imgBackground}>
      <div className={classes.rootGrid}>
        <div>
          <h6 className={classes.titulo}>
            {"Bem-vindo ao "}
            <span style={{color: "#FFCD07"}}>{"Meu INSS"}</span>
          </h6>
        </div>
        <div>
          <p className={classes.subtitulo}>
            {"Serviços que você tem aqui:"}
          </p>
        </div>
        <div style={{ display: "flex", justifyContent: "space-evenly"}}>
          <div className={classes.containerParagrafo}>
            <p className={classes.paragrafo}>
              <i className={`${classes.icone} fas fa-calendar-plus`}></i> {"Pedidos, Agendamentos, Simulações"}
            </p>
          </div>   
        </div>
        <div style={{ display: "flex", justifyContent: "space-evenly"}}>
          <div className={classes.containerParagrafo}>
            <p className={classes.paragrafo} style={{whiteSpace: "pre-line"}}>
             <i className={`${classes.icone} fas fa-print`}></i> {"Comprovantes, Extratos, Declarações"}
            </p>
          </div>   
        </div>
        <div style={{ display: "flex", justifyContent: "space-evenly"}}>
          <div className={classes.containerParagrafo}>
            <p className={classes.paragrafo}>
              <i className={`${classes.icone} fas fa-hand-holding-usd`}></i> {"Aposentadoria, Pensão, BPC e mais!"}
            </p>
          </div>   
        </div>
        
        <div className={classes.botaoAvancar}>
          <button className="br-button secondary" onClick={() => props.callback()}>
            Avançar
          </button>
        </div>

      </div>
    </div>
  )
}